import { Trans } from '@lingui/macro'
import { Grid, Typography } from '@material-ui/core'
import React from 'react'

import image from '../assets/gateway_configure.png'
import { GatewaySetup } from '../molecules/GatewaySetup'
import { WizardStep } from '../typings/types'

export const ConfigureGatewayStep: WizardStep = ({ account }) => {
  return (
    <Grid container>
      <Grid item>
        <GatewaySetup account={account} />
      </Grid>
      <Grid item>
        <Typography variant="caption">
          <Trans>Ukázka nastavení</Trans>
        </Typography>
        <img src={image} />
      </Grid>
    </Grid>
  )
}

ConfigureGatewayStep.getStepLabel = () => <Trans>Nastavení brány</Trans>
